/**
 * @generated SignedSource<<6bfa623bd9099e12fe9395559f797e7b>>
 * @relayHash 9370e7db6b70cfded80e799f988b3474
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 1edff4238c699af5bad937b49db096f5539d5777ed72dd8403c79d52e494db42

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessOverviewTimelineQuery } from './src_jiraBusinessOverviewTimelineQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessOverviewTimelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "1edff4238c699af5bad937b49db096f5539d5777ed72dd8403c79d52e494db42",
    "metadata": {},
    "name": "src_jiraBusinessOverviewTimelineQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
